import {
  GatewayControleQuinquennal,
  GatewayQuestionnaire,
} from "@conformite/gateway";

export const axeTypeToLabel: Record<
  GatewayControleQuinquennal.ControleQuinquennalAxeType,
  string
> = {
  ASSUJETTI: "Personnes assujetties",
  RCPRO_COA: "RC Pro COA",
  RCPRO_MIA: "RC Pro MIA",
  RCPRO_COBSP: "RC Pro COBSP",
  RCPRO_MIOBSP: "RC Pro MIOBSP",
  GARANTIE_FINANCIERE_IAS: "Garantie financière IAS",
  GARANTIE_FINANCIERE_IOBSP: "Garantie financière IOBSP",
};
export const controleTypeOrder: Record<
  GatewayControleQuinquennal.ControleQuinquennalAxeType,
  number
> = {
  ASSUJETTI: 1,
  RCPRO_COA: 2,
  RCPRO_MIA: 3,
  RCPRO_COBSP: 4,
  RCPRO_MIOBSP: 5,
  GARANTIE_FINANCIERE_IAS: 6,
  GARANTIE_FINANCIERE_IOBSP: 7,
};

// KEEP IN SYNC with the gateway copy: gateway/src/controle-quinquennal/service/message/axe-type-to-slug.ts
// (axeTypeToQuestionnaireSlug). ASSUJETTI is intentionally excluded.
// Guarded on the gateway side by axe-type-to-slug.spec.ts, which fails if a new ControleQuinquennalAxeType is added there without this copy being updated to match.
export const axeTypeToQuestionnaireSlug: Partial<
  Record<
    GatewayControleQuinquennal.ControleQuinquennalAxeType,
    GatewayQuestionnaire.QuestionnaireSlug
  >
> = {
  RCPRO_COA: "cq_rcpro_coa",
  RCPRO_MIA: "cq_rcpro_mia",
  RCPRO_COBSP: "cq_rcpro_cobsp",
  RCPRO_MIOBSP: "cq_rcpro_miobsp",
  GARANTIE_FINANCIERE_IAS: "cq_gf_ias",
  GARANTIE_FINANCIERE_IOBSP: "cq_gf_iobsp",
};

export type CQParams = {
  idEntreprise: string;
  idCQ: string;
  idAxe: string;
};

export const CQ_SEARCH_PARAM = "cq";

const withCQ = (path: string, idCQ?: string) =>
  idCQ
    ? `${path}?${new URLSearchParams({ [CQ_SEARCH_PARAM]: idCQ }).toString()}`
    : path;

export const cqDossierUrl = (idEntreprise: string, idCQ?: string) =>
  withCQ(`/controle-quinquennal/${idEntreprise}`, idCQ);

export const cqRapportUrl = (idEntreprise: string, idCQ?: string) =>
  withCQ(`/controle-quinquennal/${idEntreprise}/rapport`, idCQ);
